import React from 'react'

import PollView from '../pieces/PoolView'

const MainPage = (props) => <PollView {...props} />

export default MainPage